import {AppComponent} from './app/app.component';
import {HomeComponent} from "./home/home.component";
import {LoginComponent} from './login/login.component';
import {Transition} from '@uirouter/core';
import {AbstractComponent} from './abstract/abstract.component';
import {AppAlertComponent} from './app-alert/app-alert.component';
import {TopMenuComponent} from './top-menu/top-menu.component';
import {
    AccountModulesService,
    FormsService,
    MenuService,
    ParametersService,
    SettingsAccountService,
    SettingsNotificationsDefaultService,
    SettingsNotificationsService,
    SettingsService,
} from "./core";
import {AdminComponent} from "./admin/admin.component";
import {
    SettingsAccountComponent
} from "./settings/settings-account/settings-account.component";
import {SettingsComponent} from "./settings/settings/settings.component";
import {
    DeleteAccountComponent
} from "./help/delete-account/delete-account.component";
import {
    RegistrationNewModuleComponent
} from "./settings/registration-new-module/registration-new-module.component";
import {RemoteLoginComponent} from "./remote-login/remote-login.component";
import {
    SettingsNotificationsComponent
} from "./settings/settings-notifications/settings-notifications.component";
import {
    AdditionalSoftwareComponent
} from "./settings/additional-software/additional-software.component";
import {
    ControllerSoftwareComponent
} from "./settings/controller-software/controller-software.component";
import {
    SettingsManualsComponent
} from "./settings/settings-manuals/settings-manuals.component";
import {
    SettingsTilesComponent
} from "./settings/settings-tiles/settings-tiles.component";
import {FooterComponent} from "./footer/footer.component";
import {SubmenuComponent} from "./submenu/submenu.component";
import {MenuType} from "./models";
import {LoginHeaderComponent} from "./login-header/login-header.component";
import {RegistrationComponent} from "./registration/registration.component";
import {ZoneComponent} from "./zones/zone/zone.component";
import {
    ConstantTempComponent
} from "./zones/constant-temp/constant-temp.component";
import {
    TimeLimitationComponent
} from "./zones/time-limitation/time-limitation.component";
import {ZoneInfoComponent} from "./zones/zone-info/zone-info.component";
import {
    ZoneContainerInfoComponent
} from "./zones/zone-container-info/zone-container-info.component";
import {ValveComponent} from "./zones/valve/valve.component";
import {ValveInfoComponent} from "./zones/valve-info/valve-info.component";
import {
    AdditionalContactCardComponent
} from "./zones/additional-contact-card/additional-contact-card.component";
import {
    AdditionalContactInfoComponent
} from "./zones/additional-contact-info/additional-contact-info.component";
import {
    OpenthermCardComponent
} from "./zones/opentherm-card/opentherm-card.component";
import {
    OpenthermCardInfoComponent
} from "./zones/opentherm-card-info/opentherm-card-info.component";
import { SimpleValveCardComponent } from './zones/simple-valve/simple-valve-card/simple-valve-card.component';
import { SimpleValveInfoComponent } from './zones/simple-valve/simple-valve-info/simple-valve-info.component';
import {
    ZoneScheduleComponent
} from "./zones/zone-schedule/zone-schedule.component";
import {
    ZoneScheduleSettingsComponent
} from "./zones/zone-schedule-settings/zone-schedule-settings.component";
import {
    ZoneScheduleSelectComponent
} from "./zones/zone-schedule-select/zone-schedule-select.component";
import {AccountActivationComponent} from "./account-activation/account-activation.component";
import {ConfirmDeleteAccountComponent} from "./confirm-delete-account/confirm-delete-account.component";
import {
    ZonesSettingsComponent
} from "./zones-settings/zones-settings.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {ControlsComponent} from "./controls/controls/controls.component";
import {ChangeAccountEmailController} from "./change-account-email/change-account-email-controller.component";
import {PolicyComponent} from "./policy/policy.component";
import {MaintenanceAlertComponent} from "./maintenance-alert/maintenance-alert.component";
import {AlarmHistoryComponent} from "./alarm-history/alarm-history.component";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {StatisticsComponent} from "./statistics/statistics.component";
import {NotFoundComponent} from "./not-found/not-found.component";
import {
    SettingsModuleComponent
} from "./settings/settings-module/settings-module.component";
import {
    SettingsModuleOptionsComponent
} from "./settings/settings-module-options/settings-module-options.component";

export const UNAUTHORIZED = 'unauthorized';
export const AUTHORIZED = 'authorized';

export const appState = {
    name: 'app',
    abstract: true,
    component: AppComponent,
};

export const authorizedState = {
    parent: 'app',
    name: AUTHORIZED,
    abstract: true,
    component: AbstractComponent,
    data: {requiresAuth: true},
    resolve: [{token: 'returnTo', deps: [Transition], resolveFn: returnTo}],
};

export const unauthorizedState = {
    parent: 'app',
    name: UNAUTHORIZED,
    abstract: true,
    component: AbstractComponent,
    resolve: [{token: 'returnTo', deps: [Transition], resolveFn: returnTo}],
};

export const startState = {
    parent: AUTHORIZED,
    name: 'start',
    url: '/',
}

export const accountActivation = {
    parent: UNAUTHORIZED,
    name: 'account_activation',
    url: '/account_activation',
    views: {
        headerView: {component:LoginHeaderComponent},
        mainView: {component: AccountActivationComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
    params: {
        state: null,
        client_id: null,
        scope: null,
        response_type: null,
        redirect_uri: null
    }
};

export const loginState = {
    parent: UNAUTHORIZED,
    name: 'login',
    url: '/login?state&client_id&scope&response_type&redirect_uri',
    views: {
        headerView: {component:LoginHeaderComponent},
        maintenanceAlertView: {component: MaintenanceAlertComponent},
        mainView: {component: LoginComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
    params: {
        state: null,
        client_id: null,
        scope: null,
        response_type: null,
        redirect_uri: null
    }
};

export const adminState = {
    parent: UNAUTHORIZED,
    name: 'admin',
    url: '/admin',
    views: {
        headerView: {component: LoginHeaderComponent },
        mainView: {component: AdminComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
};

export const policy = {
    parent: UNAUTHORIZED,
    name: 'policy',
    url: '/web/{selectedModuleHash}/policy',
    views: {
        mainView: {component: PolicyComponent },
    },
};
export const resetPassword = {
    parent: UNAUTHORIZED,
    name: 'resetPassword',
    url: '/reset_password',
    views: {
        headerView: {component: LoginHeaderComponent },
        mainView: {component: ResetPasswordComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
};

export const forgotPassword = {
    parent: UNAUTHORIZED,
    name: 'forgotPassword',
    url: '/login?state&client_id&scope&response_type&redirect_uri',
    views: {
        headerView: {component: LoginHeaderComponent },
        mainView: {component: ForgotPasswordComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
};

export const changeAccountEmail = {
    parent: UNAUTHORIZED,
    name: 'change_account_email',
    url: '/change_account_email',
    views: {
        headerView: {component: LoginHeaderComponent },
        mainView: {component: ChangeAccountEmailController},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
};

export const homeState = {
    parent: AUTHORIZED,
    name: 'home',
    url: '/web/{selectedModuleHash}/home',
    views: {
        headerView: {component: TopMenuComponent},
        maintenanceAlertView: { component: MaintenanceAlertComponent},
        mainView: {component: HomeComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService],
        resolveFn: (accountModules: AccountModulesService) => accountModules.downloadModules()
    }],
};

export const serviceMenuState = {
    parent: AUTHORIZED,
    name: 'service_menu',
    url: '/web/{selectedModuleHash}/service_menu',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: SubmenuComponent},
        footerView: {component: FooterComponent },
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService, MenuService],
        resolveFn: (accountModules: AccountModulesService, menu: MenuService) => {
            if(menu.allElementMenu === undefined) {
                accountModules.downloadModules();
                accountModules.getMenuItems(MenuType.MS);
            }
        }
    }],
};

export const fittersMenuState = {
    parent: AUTHORIZED,
    name: 'fitters_menu',
    url: '/web/{selectedModuleHash}/fitters_menu',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: SubmenuComponent},
        footerView: {component: FooterComponent },
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService, MenuService],
        resolveFn: (accountModules: AccountModulesService, menu: MenuService) => {
            if(menu.allElementMenu === undefined) {
                accountModules.downloadModules();
                accountModules.getMenuItems(MenuType.MI);
            }
        }
    }],
};

export const manufacturerMenuState = {
    parent: AUTHORIZED,
    name: 'manufacturer_menu',
    url: '/web/{selectedModuleHash}/manufacturer_menu',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: SubmenuComponent},
        footerView: {component: FooterComponent },
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService, MenuService],
        resolveFn: (accountModules: AccountModulesService, menu: MenuService) => {
            if(menu.allElementMenu === undefined) {
                accountModules.downloadModules();
                accountModules.getMenuItems(MenuType.MP);
            }
        }
    }],
};

export const menuState = {
    parent: AUTHORIZED,
    name: 'menu',
    url: '/web/{selectedModuleHash}/menu',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: SubmenuComponent},
        footerView: {component: FooterComponent },
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService, MenuService],
        resolveFn: (accountModules: AccountModulesService, menu: MenuService) => {
            if(menu.allElementMenu === undefined) {
                accountModules.downloadModules();
                accountModules.getMenuItems(MenuType.MU);
            }
        }
    }],
};

export const zoneState = {
    parent: AUTHORIZED,
    name: 'zone',
    url: '/web/{selectedModuleHash}/zone',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ZoneComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService],
        resolveFn: (accountModules: AccountModulesService) => accountModules.downloadModules()
    }],
};

export const zoneConstantTemperatureState = {
    parent: AUTHORIZED,
    name: 'zone_constant_temperature',
    url: '/web/{selectedModuleHash}/zone/temperature',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ConstantTempComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const zoneTimeLimitationState = {
    parent: AUTHORIZED,
    name: 'zone_time_limitation',
    url: '/web/{selectedModuleHash}/zone/temperature/time',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: TimeLimitationComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const zoneInfoState = {
    parent: AUTHORIZED,
    name: 'zone_info',
    url: '/web/{selectedModuleHash}/zone/info',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ZoneInfoComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const zoneContainerInfoState = {
    parent: AUTHORIZED,
    name: 'zone_container_info_with_template',
    url: '/web/{selectedModuleHash}/zone/zone-container-info',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ZoneContainerInfoComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const zoneScheduleState = {
    parent: AUTHORIZED,
    name: 'zone_schedule_select',
    url: '/web/{selectedModuleHash}/zone/schedule',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ZoneScheduleComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const zoneScheduleSettingsState = {
    parent: AUTHORIZED,
    name: 'zone_schedule_settings',
    url: '/web/{selectedModuleHash}/zone/schedule/settings',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ZoneScheduleSettingsComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const zoneScheduleSelectZonesState = {
    parent: AUTHORIZED,
    name: 'select_zones',
    url: '/web/{selectedModuleHash}/zone/schedule/settings/select',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ZoneScheduleSelectComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const valveState = {
    parent: AUTHORIZED,
    name: 'valve_select',
    url: '/web/{selectedModuleHash}/valve',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ValveComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const valveInfoState = {
    parent: AUTHORIZED,
    name: 'valve_info',
    url: '/web/{selectedModuleHash}/valve/info',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ValveInfoComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const additionalContactState = {
    parent: AUTHORIZED,
    name: 'additional_contact_select',
    url: '/web/{selectedModuleHash}/additional_contact',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: AdditionalContactCardComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const additionalContactInfoState = {
    parent: AUTHORIZED,
    name: 'additional_contact_info',
    url: '/web/{selectedModuleHash}/additional_contact/info',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: AdditionalContactInfoComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const openthermState = {
    parent: AUTHORIZED,
    name: 'openTherm_select',
    url: '/web/{selectedModuleHash}/opentherm',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: OpenthermCardComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const openthermInfoState = {
    parent: AUTHORIZED,
    name: 'opentherm_info',
    url: '/web/{selectedModuleHash}/opentherm/info',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: OpenthermCardInfoComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const simpleValveState = {
    parent: AUTHORIZED,
    name: 'simple_valve_select',
    url: '/web/{selectedModuleHash}/simple-valve',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: SimpleValveCardComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const simpleValveInfoState = {
    parent: AUTHORIZED,
    name: 'simple_valve_info',
    url: '/web/{selectedModuleHash}/simple-valve/info',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: SimpleValveInfoComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    }
};

export const controlState = {
    parent: AUTHORIZED,
    name: 'control',
    url: '/web/{selectedModuleHash}/control',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ControlsComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
};

export const alarm_history = {
    parent: AUTHORIZED,
    name: 'alarm_history',
    url: '/web/{selectedModuleHash}/alarm_history',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: AlarmHistoryComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService],
        resolveFn: (accountModules: AccountModulesService) => accountModules.downloadModules()
    }],
};

export const zonesSettingsState = {
    parent: AUTHORIZED,
    name: 'zones_settings',
    url: '/web/{selectedModuleHash}/zones_settings',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: ZonesSettingsComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService],
        resolveFn: (accountModules: AccountModulesService) => accountModules.downloadModules()
    }],
};

export const settingsState = {
    parent: AUTHORIZED,
    name: 'settings',
    url: '/web/{selectedModuleHash}/settings',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: SettingsComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService, FormsService, ParametersService,
            SettingsService, SettingsAccountService, SettingsNotificationsService,
            SettingsNotificationsDefaultService
        ],
        resolveFn: (
            accountModules: AccountModulesService,
            forms: FormsService,
            parameters: ParametersService,
            settings: SettingsService,
            settingsAccount: SettingsAccountService,
            settingsNotifications: SettingsNotificationsService,
        ) => {
            if (parameters.modules.length > 0 && forms.showModuleCountry.length === 0) {
                forms.getCountryInitial();
            }

            if (parameters.modules.length === 0) {
                accountModules.getModules().add(() => {
                    forms.getCountryInitial();
                    settingsAccount.getAccountInformation();
                    settingsNotifications.getAllPushDevices();
                    settingsNotifications.getAssignedAccounts();
                    settings.setModulesInformation();
                });
            }
        }
    }],
}

export const settingsAccountState = {
    name: 'settings.account',
    url: '/account',
    component: SettingsAccountComponent,
}

export const registration = {
    parent: UNAUTHORIZED,
    name: 'registration',
    url: '/registration',
    views: {
        headerView: {component: LoginHeaderComponent},
        mainView: {component: RegistrationComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
}

export const settingsModuleInfoState = {
    name: 'settings.module_info',
    url: '/module_info',
    component: SettingsModuleComponent,
}


export const settingsNotificationsState = {
    name: 'settings.notifications',
    url: '/notifications',
    component: SettingsNotificationsComponent,
}

export const settingsDeleteAccountState = {
    parent: AUTHORIZED,
    name: 'delete_account_settings',
    url: '/settings/delete_account',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: DeleteAccountComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
}

export const settingsDeleteAccountLoginState = {
    parent: UNAUTHORIZED,
    name: 'delete_account_login',
    url: '/help/delete_account',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: DeleteAccountComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
}

export const settingsAdditionalSoftwareState = {
    name: 'settings.additional_software',
    url: '/additional_software',
    component: AdditionalSoftwareComponent,
}

export const settingsControllerSoftwareState = {
    name: 'settings.controller_software',
    url: '/controller_software',
    component: ControllerSoftwareComponent,
}

export const settingsManualsState = {
    name: 'settings.manuals',
    url: '/manuals',
    component: SettingsManualsComponent,
}

export const settingsRegistrationNewModuleState = {
    name: 'settings.registration_new_module',
    url: '/registration_new_module',
    component: RegistrationNewModuleComponent,
}

export const settingsTilesState = {
    name: 'settings.tiles',
    url: '/tiles',
    component: SettingsTilesComponent,
}

export const settingsModuleOptionsState = {
    name: 'settings.module_options',
    url: '/module_options',
    component: SettingsModuleOptionsComponent,
}

export const deleteAccountConfirm = {
    parent: UNAUTHORIZED,
    name: 'deleteAccountConfirm',
    url: '/delete_account_confirmation_code',
    views: {
        headerView: {component: LoginHeaderComponent},
        mainView: {component: ConfirmDeleteAccountComponent},
        footerView: {component: FooterComponent},
        alertView: {component: AppAlertComponent},
    },
}

export const remoteState = {
    parent: UNAUTHORIZED,
    name: 'remote',
    url: '/remote/{openerIndex}',
    views: {
        mainView: {
            component: RemoteLoginComponent,
        }
    },
}

export const statisticsState = {
    parent: AUTHORIZED,
    name: 'statistics',
    url: '/web/{selectedModuleHash}/statistics',
    views: {
        headerView: {component: TopMenuComponent},
        mainView: {component: StatisticsComponent},
        footerView: {component: FooterComponent },
        alertView: {component: AppAlertComponent},
    },
    resolve: [{
        token: "_accountModules",
        deps: [AccountModulesService],
        resolveFn: (accountModules: AccountModulesService) => {
                accountModules.downloadModules();
        }
    }],
};

export const error404 = {
    parent: UNAUTHORIZED,
    name: 'otherwise',
    url: '*path',
    views: {
        mainView: { component: NotFoundComponent},
        alertView: {component: AppAlertComponent},
    },
}

export function returnTo($transition$: Transition): any {
    if ($transition$.redirectedFrom() != null) {
        // The user was redirected to the login state (e.g., via the requiresAuth hook when trying to activate contacts)
        // Return to the original attempted target state
        return $transition$.redirectedFrom().targetState();
    }

    const $state = $transition$.router.stateService;

    // The user was not redirected to the login state; they directly activated the login state somehow.
    // Return them to the state they came from.
    if ($transition$.from().name !== '') {
        return $state.target($transition$.from(), $transition$.params('from'));
    }

    // If the fromState's name is empty, then this was the initial transition. Just return them to the home state
    return $state.target('home');
}

export const APP_STATES = [
    appState,
    authorizedState,
    unauthorizedState,
    startState,
    loginState,
    adminState,
    homeState,
    serviceMenuState,
    fittersMenuState,
    manufacturerMenuState,
    menuState,
    zoneState,
    zoneConstantTemperatureState,
    zoneTimeLimitationState,
    zoneInfoState,
    zoneContainerInfoState,
    zoneScheduleState,
    zoneScheduleSettingsState,
    zoneScheduleSelectZonesState,
    valveState,
    valveInfoState,
    additionalContactState,
    additionalContactInfoState,
    openthermState,
    openthermInfoState,
    simpleValveState,
    simpleValveInfoState,
    controlState,
    zonesSettingsState,
    settingsState,
    settingsAccountState,
    settingsModuleInfoState,
    settingsNotificationsState,
    settingsDeleteAccountState,
    settingsDeleteAccountLoginState,
    settingsRegistrationNewModuleState,
    settingsAdditionalSoftwareState,
    settingsControllerSoftwareState,
    settingsManualsState,
    settingsTilesState,
    settingsModuleOptionsState,
    remoteState,
    registration,
    accountActivation,
    deleteAccountConfirm,
    resetPassword,
    changeAccountEmail,
    policy,
    alarm_history,
    forgotPassword,
    statisticsState,
    error404,
];
